import { useTheme } from "@mui/material";
import { SxConfig, SxProps } from "@mui/system";
import { svgAvatar, svgCheckMark, svgUnderlying, svgWikifolio } from "src/components/common/rich-text/constants";
import Theme from "src/theme-mui/theme";
import { getIconRule } from "./utils";

const LIST_INDENT = {
    xs: 3,
    sm: 5,
};

export const CENTERED_RICH_TEXT_SX: SxProps<typeof Theme> = {
    textAlign: "center",
    "& ul, & ol, & ul.checkmark": {
        ml: 0,
        pl: 0,
        textAlign: "center",
        listStylePosition: "inside",
    },
};

const getSx = (linkGray: SxConfig): SxProps<typeof Theme> => ({
    "& p": {
        mb: 3,
        "&:last-of-type": {
            mb: 0,
        },
    },
    "& ul": {
        ml: LIST_INDENT,
    },
    "& ul.checkmark": {
        listStyle: `url("data:image/svg+xml;utf8,${svgCheckMark}")`,
    },
    "& ol": {
        ml: LIST_INDENT,
        counterReset: "customlistcounter",
        "& li": {
            counterIncrement: "customlistcounter",
            "::marker": {
                content: 'counter(customlistcounter) "  "',
                fontWeight: "bold",
            },
        },
    },
    "& li": {
        my: 2,
    },
    '& a[class^="icon"]': {
        display: "inline-flex",
        alignItems: "baseline",
        lineHeight: "1",
    },
    "a:not(.button, .arrow-link)": {
        ...linkGray,
        textDecoration: "underline",
    },
    "& .icon-profile": getIconRule(svgAvatar),
    "& .icon-underlying": getIconRule(svgUnderlying),
    "& .icon-wf": getIconRule(svgWikifolio),
});

export const useSimpleRichText = () => {
    const theme = useTheme();
    let linkGray: SxConfig = {};

    const root = theme.components?.MuiLink?.styleOverrides?.root;
    if (typeof root === "function") {
        linkGray = (root({ theme, ownerState: { color: "gray" } }) as SxConfig) || {};
    }

    return getSx(linkGray);
};
